import { FunctionComponent } from "react";

interface FooterLinkWrapperProps {
  children: React.ReactNode;
}

const FooterLinkWrapper: FunctionComponent<FooterLinkWrapperProps> = ({
  children,
}) => {
  return <div>{children}</div>;
};

export default FooterLinkWrapper;
